import { Tabs } from 'antd';
import { Redirect } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAddressBook } from '@fortawesome/free-solid-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { SettingOutlined } from '@ant-design/icons';

import { useAppSelector } from 'flex/utils';
import { useFeatures } from 'constants/CustomHooks/useFeatures';
import { useTabManagement } from 'constants/CustomHooks/useTabManagement';
import { useHasTouchScreen } from 'constants/CustomHooks/useHasTouchScreen';
import SettingTab from './Setting';
import 'styles/pages/security.scss';
import MfaManagement from './MfaManagement';

const { TabPane } = Tabs;

/** タブキー定数 */
export const TabKeyEnum = {
    SETTINGS: 'settings' as const,
    MANAGEMENT: 'management' as const,
};

/**
 * セキュリティ設定ページ
 * 設定タブと監視タブを管理する
 */
const Security = () => {
    const features = useFeatures();

    // テナントの多要素認証機能が無効な場合、学校管理者には表示しない（URL直接アクセス対策）
    if (!features.isLoading && !features.security) {
        return <Redirect to='/' />;
    }

    return <SecurityContent />;
};

const SecurityContent = () => {
    const isControllableUser = useAppSelector(
        (state) => state.isControllableUser.payload,
    );
    const [tabActiveKey, setTabActiveKey] = useTabManagement(
        TabKeyEnum,
        isControllableUser ? TabKeyEnum.SETTINGS : TabKeyEnum.MANAGEMENT,
    );
    //タッチ機能のあるデバイスかどうか
    const { hasTouchScreen } = useHasTouchScreen();

    return (
        <div className='card-container'>
            <Tabs activeKey={tabActiveKey} onChange={setTabActiveKey}>
                {isControllableUser && (
                    // 設定タブ
                <TabPane key={TabKeyEnum.SETTINGS} tab={<span><SettingOutlined />設定</span>}>
                    <SettingTab
                        tabActiveKey={tabActiveKey}
                        hasTouchScreen={hasTouchScreen}
                    />
                </TabPane>
                )}

                {/* MFA管理 */}
                <TabPane
                    key={TabKeyEnum.MANAGEMENT}
                    tab={
                        <span>
                            <FontAwesomeIcon icon={faAddressBook as IconProp} style={{marginRight: '12px'}}/>
                            MFA管理
                        </span>
                    }
                >
                    <MfaManagement
                        tabActiveKey={tabActiveKey}
                        hasTouchScreen={hasTouchScreen}
                    />
                </TabPane>
            </Tabs>
        </div>
    );
};

export default Security;
